module.exports = "/img/picIcon.db65acb1.png";